export default function HistoryHeadcountLine({
  before,
  after,
  delta,
}: {
  before: number;
  after: number;
  delta: number;
}) {
  const up = delta > 0;
  return (
    <div style={{ overflowWrap: 'anywhere', fontSize: 12.5, color: 'var(--nb-ink)' }}>
      Headcount{' '}
      <span
        className="nb-tabular"
        style={{
          fontWeight: 700,
          textDecoration: 'line-through',
          textDecorationColor: 'var(--nb-faint)',
          color: 'var(--nb-subtle)',
        }}
      >
        {before}
      </span>
      <span style={{ color: 'var(--nb-faint)' }}>{' → '}</span>
      <span className="nb-tabular" style={{ fontWeight: 800, fontSize: 13.5 }}>
        {after}
      </span>
      <span
        style={{
          marginLeft: 6,
          fontSize: 10.5,
          fontWeight: 700,
          color: up ? 'var(--nb-primary-2)' : 'var(--nb-warn)',
        }}
      >
        {up ? `+${delta}` : `−${Math.abs(delta)}`}
      </span>
    </div>
  );
}
